// @flow
import ACTIONS from '../actions/recentlyViewed';
import type {Action} from '../actions/recentlyViewed';
import type {RecentlyViewedPropertyShape} from '../components/PropertyCarousel/PropertyCarousel';

export type State = {
    pageIndex: number,
    listings: RecentlyViewedPropertyShape[]
};

const initialState = {
    pageIndex: 0,
    listings: []
};

export default function reducer(
    state: State = initialState,
    action: Action
): State {
    if (action.type === ACTIONS.PREV_PAGE) {
        const {pageIndex} = state;

        return {
            ...state,
            pageIndex: pageIndex > 1 ? pageIndex - 1 : pageIndex
        };
    }

    if (action.type === ACTIONS.NEXT_PAGE) {
        const {pageIndex} = state;

        return {
            ...state,
            pageIndex: pageIndex + 1
        };
    }

    if (action.type === ACTIONS.FETCH_LISTINGS_SUCCESS) {
        return {
            ...state,
            listings: [...state.listings, ...action.payload.listings]
        };
    }
    return state;
}
